export const SIGN_IN_START = 'SIGN_IN_START';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_FAIL = 'SIGN_IN_FAIL';
export const SET_REDIRECT = 'SET_REDIRECT';
export const ClEAR_ERROR = 'ClEAR_ERROR';